module.exports = __webpack_public_path__ + "img/car.988869c8.webp";